import { readPref, writePref } from '../ui/prefs';

/**
 * Consentement à la télémétrie (A78, A80) : **actif par défaut**, désactivable
 * dans les options de l'Accalmie. Préférence du navigateur, hors sauvegarde.
 *
 *  - clé absente ou `'1'` : actif ;
 *  - `'0'` : inactif — aucune collecte, aucune mise en file, file vidée, aucun
 *    envoi (l'identifiant d'installation est conservé).
 *
 * Module minuscule et sans dépendance lourde : l'écran de l'Accalmie l'importe
 * sans tirer le reste de la télémétrie.
 */

export const CONSENT_KEY = 'diceordie.telemetry.consent';

type Listener = (on: boolean) => void;
const listeners = new Set<Listener>();

/** Consentement courant (`true` par défaut). */
export function readConsent(): boolean {
  return readPref(CONSENT_KEY) !== '0';
}

/** Règle le consentement, prévient les abonnés (la télémétrie vide alors sa file) et renvoie la valeur retenue. */
export function writeConsent(on: boolean): boolean {
  writePref(CONSENT_KEY, on ? '1' : '0');
  for (const fn of Array.from(listeners)) {
    try {
      fn(on);
    } catch {
      /* un abonné défaillant ne doit jamais gêner l'option */
    }
  }
  return on;
}

export function onConsentChange(fn: Listener): () => void {
  listeners.add(fn);
  return () => {
    listeners.delete(fn);
  };
}
